export default {
  undoBtn: 'undo-button',
  redoBtn: 'redo-button',
};
